import { render } from "./IndexGeoloc.vue?vue&type=template&id=046bebbc"
import script from "./IndexGeoloc.vue?vue&type=script&lang=js"
export * from "./IndexGeoloc.vue?vue&type=script&lang=js"

import "./IndexGeoloc.vue?vue&type=style&index=0&id=046bebbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__